module.exports = __webpack_public_path__ + "static/media/logo.23b0af85.png";